import { getAuthMeUser } from '@/core/services/ota'
import { NewOrderBundle } from '@/enums/general'
import { OrderTypes, OrderTypesType } from '@/enums/ota/orders'
import { isMysteryOrder } from '@/utils/ota/orders'
import { isAfter, parseISO } from 'date-fns'

export const isMysteryOrderBundle = (orderBundle: NewOrderBundle) => {
  return !!orderBundle.orders.find((order) => isMysteryOrder(order))
}

export const isOrderBundleOfType = (orderBundle: NewOrderBundle, type: OrderTypesType) =>
  orderBundle.orders.some((order) => order.type === type)

export const isMonthlyOrderBundle = (orderBundle: NewOrderBundle) => isOrderBundleOfType(orderBundle, OrderTypes.membership)

export const hasAtleastOneLoyaltyOrderBundle = (orderBundles: NewOrderBundle[]) =>
  orderBundles.some((orderBundle) => isOrderBundleOfType(orderBundle, OrderTypes.loyalty))

export const getLatestMonthlyOrderBundle = (orderBundles: NewOrderBundle[]) =>
  orderBundles.find((orderBundle) => isMonthlyOrderBundle(orderBundle))

export const getDelayedDeliveryDate = (user: getAuthMeUser, nextDeliveryDateString: string | undefined): string | null => {
  let delayedDeliveryDate: string | null = null

  if (user && nextDeliveryDateString) {
    user.orderBundles.edges.some((orderBundle) =>
      orderBundle.node.orders.edges.some((order) => {
        if (order.node.delayedDeliveryDate && orderBundle.node.payment?.status === 1) {
          if (isAfter(parseISO(order.node.delayedDeliveryDate), parseISO(nextDeliveryDateString))) {
            delayedDeliveryDate = order.node.delayedDeliveryDate
          }
        }
      })
    )
  }

  return delayedDeliveryDate
}
